import { render, staticRenderFns } from "./showAppDetail.vue?vue&type=template&id=cc1baaf2&scoped=true&"
import script from "./showAppDetail.vue?vue&type=script&lang=js&"
export * from "./showAppDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1baaf2",
  null
  
)

export default component.exports